import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';

interface Props {
  children: React.ReactNode;
}

export function ProtectedSuperadminRoute({ children }: Props) {
  const user = useAuthStore((s) => s.user);

  if (!user?.isSuperadmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
